import { render, staticRenderFns } from "./PengaturanAkunPemilikSistem.vue?vue&type=template&id=3267f716&scoped=true&"
import script from "./PengaturanAkunPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./PengaturanAkunPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3267f716",
  null
  
)

export default component.exports